/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.custom.views.realtime.rpc.CvCustomViewsRealtimeRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const CrmObjectKeyTypename = 'com.hubspot.cv.custom.views.core.CrmObjectKey';
export const ThreadKeyTypename = 'com.hubspot.cv.custom.views.core.ThreadKey';
export const AgentSenderTypename = 'com.hubspot.cv.pubsub.core.message.common.AgentSender';
export const BotSenderTypename = 'com.hubspot.cv.pubsub.core.message.common.BotSender';
export const IntegratorSenderTypename = 'com.hubspot.cv.pubsub.core.message.common.IntegratorSender';
export const SystemSenderTypename = 'com.hubspot.cv.pubsub.core.message.common.SystemSender';
export const VidSenderTypename = 'com.hubspot.cv.pubsub.core.message.common.VidSender';
export const VisitorSenderTypename = 'com.hubspot.cv.pubsub.core.message.common.VisitorSender';
export const HelpDeskSearchViewMemberTypename = 'com.hubspot.cv.pubsub.core.message.viewmember.HelpDeskSearchViewMember';
export const HelpDeskViewMemberTypename = 'com.hubspot.cv.pubsub.core.message.viewmember.HelpDeskViewMember';
export const InboxViewMemberTypename = 'com.hubspot.cv.pubsub.core.message.viewmember.InboxViewMember';
export const getViewMembersForRealtimeRpc = {
  serviceName: 'com.hubspot.cv.custom.views.realtime.rpc.CvCustomViewsRealtimeRpc',
  rpcName: 'getViewMembersForRealtime',
  auth: 'app',
  fingerprint: 'MG0NIJjOmTuO5183ixc5EpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCustomViewCountsRpc = {
  serviceName: 'com.hubspot.cv.custom.views.realtime.rpc.CvCustomViewsRealtimeRpc',
  rpcName: 'getCustomViewCounts',
  auth: 'app',
  fingerprint: 'ZEVQ1DtoZSmBfL1ysldjJZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getObjectIdsThatPassMembershipCheckRpc = {
  serviceName: 'com.hubspot.cv.custom.views.realtime.rpc.CvCustomViewsRealtimeRpc',
  rpcName: 'getObjectIdsThatPassMembershipCheck',
  auth: 'app',
  fingerprint: 'k4uVX5ADEy8GVqIWH_zqQpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const checkQuickFiltersRpc = {
  serviceName: 'com.hubspot.cv.custom.views.realtime.rpc.CvCustomViewsRealtimeRpc',
  rpcName: 'checkQuickFilters',
  auth: 'app',
  fingerprint: 'x1G02R_qlNhKtw-9Gfw2S5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};